import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
/** Like string.join() but with React nodes :) */
export const jsxJoin = (items, glue) => {
    let previousItem;
    return Children.map(items, (item) => {
        if (!item) {
            return;
        }
        const glueElement = previousItem && item && glue;
        previousItem = item;
        return (_jsxs(_Fragment, { children: [glueElement, item] }));
    });
};
export default jsxJoin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianN4Sm9pbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvanN4Sm9pbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLE9BQU8sRUFBRSxRQUFRLEVBQWEsTUFBTSxPQUFPLENBQUM7QUFFNUMsaURBQWlEO0FBQ2pELE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBRyxDQUFDLEtBQWdCLEVBQUUsSUFBZSxFQUFhLEVBQUU7SUFDdEUsSUFBSSxZQUF1QixDQUFDO0lBRTVCLE9BQU8sUUFBUSxDQUFDLEdBQUcsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxJQUFJLEVBQUUsRUFBRTtRQUNsQyxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDVixPQUFPO1FBQ1QsQ0FBQztRQUVELE1BQU0sV0FBVyxHQUFHLFlBQVksSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDO1FBQ2pELFlBQVksR0FBRyxJQUFJLENBQUM7UUFFcEIsT0FBTyxDQUNMLDhCQUNHLFdBQVcsRUFDWCxJQUFJLElBQ0osQ0FDSixDQUFDO0lBQ0osQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixlQUFlLE9BQU8sQ0FBQyJ9